import { useNavigate } from 'react-router-dom';
import { COLORS } from '../../../func/components/Color';
import { ReportFormatNumber } from '../../../func/Function';
import styled from 'styled-components';
import Tags from '../../../func/Tags';
import UserService from '../../../service/User';
import { useModal } from '../../../context/ModalContext';

const ImminentItem = ({ item, loginYN }: any) => {
  // console.log('ImminentItem', item);
  const navigate = useNavigate();

  const showAlert = (message: string, navigation: any) => {
    const confirmed = window.confirm(message);
    if (confirmed) {
      navigate('/login');
    }
  };

  const formatSaleDate = (saledate: string) => {
    if (item.type === 'p') {
      return saledate.replace('10:00', '').replace('17:00', '');
    }
    return saledate;
  };
  const { modalDispatch } = useModal();
  return (
    <SlideCard
      onClick={async () => {
        if (loginYN) {
          localStorage.setItem(
            'tab',
            item.type === 'a' ? 'auction' : 'pauction',
          );
          navigate(
            `${item.type === 'a' ? '/auction' : '/pauction'}/detail/${item.iidx}`,
          );

          // navigate(item.type === 'a' ? '/Auction' : '/PAuction', {
          //   mode: item.type === 'a' ? 'auction' : 'pauction',
          //   search: item.caseno,
          //   court: item.courtname,
          //   unitno: item.unitno,
          // } as any);
        } else {
          modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
        }
      }}
    >
      <SlideInner>
        <ItemImgBox>
          <ImgTag>{item.type === 'a' ? '경매' : '공매'}</ImgTag>
          <img
            src={item.img}
            alt=""
            style={{ width: '100%', height: '100%' }}
          />
          <ItemImgTextBox>
            <ItemImgText>
              <div>{item.type === 'a' ? '매각기일' : '입찰기간'}</div>
              <div>{formatSaleDate(item.saledate)}</div>
            </ItemImgText>
            <ItemImgText>
              <img src="/assets/images/icon/view-white.svg"></img>
              <div>{item.views}회</div>
            </ItemImgText>
          </ItemImgTextBox>
        </ItemImgBox>
        <ItemDetailBox>
          <DetailWrapper>
            <ItemDetail>
              <InfoWrapper>
                <Info>
                  <div>{item.caseno}</div>
                  <div>|</div>
                  <div>{item.courtname}</div>
                </Info>
              </InfoWrapper>
            </ItemDetail>
            <ItemDetail>
              <ItemAddress>{item.address}</ItemAddress>
            </ItemDetail>
            <ItemDetail>
              <ItemAddress>
                <InfoWrapper>
                  <Info>
                    <div>{item.itemCategory}</div>
                    <div>|</div>
                    {item.buildingArea && item.buildingArea !== 0 && (
                      <>
                        <div>
                          건물 {Number(item.buildingArea ?? 0).toFixed(1)}m²
                        </div>
                        <div>|</div>
                      </>
                    )}
                    <div>토지 {Number(item.landArea ?? 0).toFixed(1)}m²</div>
                  </Info>
                </InfoWrapper>
              </ItemAddress>
            </ItemDetail>
          </DetailWrapper>
          <DetailWrapper>
            <PriceBox>
              <div>감정가 {ReportFormatNumber(item.appraisePrice)} </div>
              <SalePriceTextBlue>
                최저가 {ReportFormatNumber(item.minPrice)}
              </SalePriceTextBlue>
            </PriceBox>
            <HashTagWrapper>
              <Tags data={{ ...item, viewgray2: item.viewgray }}></Tags>
            </HashTagWrapper>
          </DetailWrapper>
        </ItemDetailBox>
      </SlideInner>
    </SlideCard>
  );
};

export default ImminentItem;

const HashTag = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 4px;
`;

const HashTagWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  break-word: break-word;

  color: rgba(23, 30, 38, 0.78);
  font-size: 12px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 17.4px;
  word-wrap: break-word;

  span {
    color: rgba(250, 64, 50, 0.98);
  }
`;

interface TagProps {
  type: string;
}

const DetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Info = styled.div`
  display: flex;
  flex-direction: row;
  gap: 4px;
  white-space: nowrap;
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  color: rgba(23, 30, 38, 0.56);
  font-size: 12px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 17.4px;
  letter-spacing: -0.7px;

  word-wrap: break-word;
`;

const Tag = styled.div<TagProps>`
  width: 40px;
  paddingb-lock: 2px;
  padding-inline: 8px;
  border-radius: 50px;
  font-family: Spoqa Han Sans Neo;
  font-size: 14x;
  font-weight: 500;
  color: ${(props) => (props.type === 'a' ? '#D84836' : '#0C64CE')};
  background-color: ${(props) => (props.type === 'a' ? '#FFDBD6' : '#DEEDFF')};
`;

const styles = {
  tag: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: 'auto',
    borderRadius: 8,
    paddingBlock: '4px',
    paddingInline: '8px',
    border: '1px solid #171E261A',
    fontFamily: 'Spoqa Han Sans Neo',
    fontSize: '12px',
    fontWeight: '500',
    lineHeight: '17.4px',
    color: '#171E268F',
  },
};

const SlideCard = styled.div`
  min-width: 282px;
  height: auto;
  border-radius: 16px;
  background-color: #fff;
  overflow: hidden;
  // border: 1px solid rgba(112, 115, 124, 0.16);
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  cursor: pointer;
  margin-bottom: 24px;
`;

const ImgTag = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  border-top-left-radius: 8px;
  border-bottom-right-radius: 8px;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 6px 10px;
  color: #fff;
  font-size: 14px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 20.3px;
  word-wrap: break-word;
`;

const ItemImgBox = styled.div`
  position: relative;
  width: 100%;
  height: 178px;
  display: flex;
  // border-bottom: 1px solid ${COLORS.borderGray};
  position: relative;
  overflow: hidden;
  img {
    border-radius: 8px;
  }
`;

const ItemImgTextBox = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 8px 14px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 8px;
  background-color: rgba(0, 0, 0, 0.5);
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
`;
const ItemImgText = styled.div`
  color: #fff;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-weight: 700;
  letter-spacing: -0.7px;
  line-height: 17.4px;
  white-space: nowrap;
  display: flex;
  flex-direction: row;
  gap: 4px;
`;

const ItemDetailBox = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

const ItemDetail = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  font-size: 14px;
`;

const ItemDetailBottom = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-inline: 16px;
`;

const ItemNumber = styled.span`
  font-family: 'Spoqa Han Sans Neo';
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 18.85px */
  letter-spacing: -0.65px;
  color: ${COLORS.disabled};
`;

const ItemAddress = styled.span`
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.7px;
  color: #222222;
`;

const PriceBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  color: rgba(23, 30, 38, 0.78);
  font-size: 12px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 500;
  line-height: 17.4px;
  word-wrap: break-word;
`;

const SalePriceTextBlue = styled.span`
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 145%; /* 20.3px */
  letter-spacing: -0.7px;
  color: #008aff;
`;

const SlideInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;
